/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StationComparisonInterface {
  selectedStationIds: string[];
}

interface UpdateStationPayload {
  index: number;
  id: string;
}

const initialState: StationComparisonInterface = {
  selectedStationIds: [],
};

export const stationComparisonSlice = createSlice({
  name: 'station-comparison',
  initialState,
  reducers: {
    /**
     * Adding selected station ids
     * @param state
     * @param action
     */
    addSelectedStationIds: (state, action: PayloadAction<UpdateStationPayload>) => {
      const { id, index } = action.payload;

      // Expand array up to 4 if needed
      while (state.selectedStationIds.length < 4) {
        state.selectedStationIds.push('');
      }

      // Replace that index with the new id
      state.selectedStationIds[index] = id;
    },
  },
});
export const { addSelectedStationIds } = stationComparisonSlice.actions;
export default stationComparisonSlice.reducer;
